import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { StationItemNo } from '../../../../constants/Games/gameStation';
import { getStationVisual } from '../../../../constants/Games/gameStationUtils';

import './GoalStationCell.css';

export type GoalStationCellProps = {
  stationId: StationItemNo;
  name: string | undefined;
  isUnlocked: boolean;
  onClickPlay: () => void;
};

export const GoalStationCell = memo((props: GoalStationCellProps) => {
  const { stationId, isUnlocked, onClickPlay } = props;
  const { t } = useTranslation();

  return (
    <div
      className={`goal-station-cell ${isUnlocked ? 'unlocked' : 'locked'}`}
      onClick={onClickPlay}
    >
      <div className="centered-container">
        <div className="lower-row">
          <div className={`${'component'} ${isUnlocked ? '' : 'gray-scale'}`}>
            <img
              src={getStationVisual(stationId)?.filePrefix}
              className="large-icon"
              alt="Large Icon"
            />
            <div className="text-overlay">{t('Goal')}</div>
          </div>
          <div
            className={`game-component ${isUnlocked ? 'unlocked' : 'locked'}`}
          >
            <div className="upper-part">
              <div className="left-part">
                <div className="title">{t('Goal')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
